/* eslint-disable camelcase */
import { CustomerSupportFormInput, PublicMemberValidationResponse } from '@optimus/models';
import {
  LoginMemberRequest,
  LoginMemberResponse,
  LoginSessionResponse,
  LogoutResponse,
  MemberRegistrationRequest,
  MemberRegistrationResponse,
  PublicMemberValidationRequest,
} from '../common/models/AuthenticationRequest';
import { axiosInstance, uninterceptedAxiosInstance } from './apiConfig';
import { SubmitSupportFormResponse } from '../common/models/SubmitSupportFormResponse';

export const generateMagicLinkLoginSession = async (
  email: string,
  recaptchaV2Token?: string,
  recaptchaV3Token?: string,
  afterLoginPath?: string,
) => {
  const { data } = await uninterceptedAxiosInstance.post('/auth/login-session/magic-link', {
    email,
    recaptchaV2Token,
    recaptchaV3Token,
    afterLoginPath,
  });
  return data as LoginSessionResponse;
};

// uses access token
export const generateTemporaryLoginCodeSso = async (accessToken: string) => {
  const { hostname, href } = window.location;

  const { data } = await uninterceptedAxiosInstance.post(
    '/auth/login-session/sso',
    hostname !== 'localhost' ? {
      hostname,
      href,
    } : undefined,
    {
      headers: {
        'X-Optimus-Authorization': `Bearer ${accessToken}`,
      },
    },
  );
  return data as LoginSessionResponse;
};

export const loginMember = async (request: LoginMemberRequest) => {
  const { data } = await uninterceptedAxiosInstance.post('/auth/login', { ...request });
  return data as LoginMemberResponse;
};

export const logoutMember = async (refreshToken: string | null) => {
  const { data } = await uninterceptedAxiosInstance.post(
    '/auth/logout',
    {
      refreshToken,
    },
  );
  return data as LogoutResponse;
};

export const submitCustomerSupportForm = async (request: CustomerSupportFormInput) => {
  const { data } = await uninterceptedAxiosInstance.post('/customer-support', { ...request });
  return data as SubmitSupportFormResponse;
};

export const memberRegistration = async (request: MemberRegistrationRequest) => {
  const { data } = await uninterceptedAxiosInstance.post('/auth/public/registration', { ...request });
  return data as MemberRegistrationResponse;
};

export const publicMemberValidation = async (
  request: PublicMemberValidationRequest,
) => {
  const { data } = await uninterceptedAxiosInstance.post('/auth/public/validation', { ...request });
  return data as PublicMemberValidationResponse;
};

export const serviceNationMemberValidation = async (
  token: string,
) => {
  const { data } = await uninterceptedAxiosInstance.post('/service-nation/sso/auth', { token });
  return data as PublicMemberValidationResponse;
};

export const getServiceNationSsoToken = async (): Promise<{ token: string }> => {
  const { data } = await axiosInstance.get('/service-nation/sso/token');
  return data as { token: string };
};

export const validateRegistrationToken = async (
  email: string,
  registrationCode: string,
) => {
  const { data } = await uninterceptedAxiosInstance.post('/auth/public/registration/validate', {
    email,
    registrationCode,
  });
  return data as { valid: boolean };
};
